<template>
	<div class="form-group">
		<label :for="name" :class="{ error: errors.has(name) }">{{ placeholder }}</label>
		<input type="range" :name="name" :id="name" v-model="model" v-validate="rules" :data-vv-as="placeholder" :placeholder="placeholder" class="form-control" :class="{ error: errors.has(name) }" :min="min" :max="max">
		<span v-if="rules" v-show="errors.has(name)" class="text-danger">{{ errors.first(name) }}</span>
	</div>
</template>

<script>
export default {
	inject: ['$validator'],
	props: [
		'value',
		'name',
		'placeholder',
		'rules',
		'min',
		'max'
	],
	computed: {
		model: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		},
		inputClass () {
			return {
				error: this.errors.has(name)
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/InputRange.vue